import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { createSelector } from 'reselect';
import { getDataWeatherCurrent, getDataWeatherData } from '../../../../../slices/thunks';
import OPlaceholder from '../../../../../Components/OElements/OPlaceholder';

const WeatherForecastVariable = ({ code_siep, lat, lon }) => {
    const dispatch = useDispatch();

    const selectorWeather = createSelector(
        (state) => state.DataWeather,
        (result) => ({
            data: result.itemDataWeather,
            isLoading: result.isLoadingList,
        })
    );

    const { data, isLoading } = useSelector(selectorWeather);



    useEffect(() => {
        if (code_siep && lat && lon) {
            dispatch(getDataWeatherCurrent({ siep: code_siep }));
        }
    }, [code_siep, lat, lon]);

    const sunriseTime = data?.sys?.sunrise
        ? new Date(data.sys.sunrise).toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        })
        : '-';

    const sunsetTime = data?.sys?.sunset
        ? new Date(data.sys.sunset).toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        })
        : '-';


    if (isLoading || !data) {
        return <OPlaceholder />
    }

    if (lat == null || lon == null) {
        return null;
    }

    const getWindIcon = (direction) => {
        switch (direction) {
            case 'N': return 'ri-arrow-up-line';
            case 'NE': return 'ri-arrow-right-up-line';
            case 'E': return 'ri-arrow-right-line';
            case 'SE': return 'ri-arrow-right-down-line';
            case 'S': return 'ri-arrow-down-line';
            case 'SO': return 'ri-arrow-left-down-line';
            case 'O': return 'ri-arrow-left-line';
            case 'NO': return 'ri-arrow-left-up-line';
            default: return 'ri-question-line'; // Un icono por defecto si la dirección es desconocida
        }
    };


    return (
        <React.Fragment>
            <section className='weather-forecast-section rounded-4'>
                <div className="d-flex gap-2">
                    <Card className="w-100 flex-fill mb-2 ">
                        <CardBody className="text-center m-0 p-1">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 text-center" style={{ width: '20%' }}>
                                    <i className="text-muted ri-cloud-line" style={{ fontSize: '24px' }}></i>
                                </div>
                                <div className="flex-grow-1">
                                    <h3 className="fs-13 fw-bold mb-0">{data?.clouds?.all ?? '-'}%</h3>
                                    <p className="fs-10 m-0 text-uppercase fw-medium text-muted text-truncate">Nubes</p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className="w-100 flex-fill mb-2">
                        <CardBody className="text-center m-0 p-1">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 text-center" style={{ width: '20%' }}>
                                    <i className="text-muted ri-drop-line" style={{ fontSize: '24px' }}></i>
                                </div>
                                <div className="flex-grow-1">
                                    <h3 className="fs-13 fw-bold mb-0">{data?.main?.humidity ?? '-'}%</h3>
                                    <p className="fs-10 m-0 text-uppercase fw-medium text-muted text-truncate">Humedad</p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                <div className="d-flex gap-2">
                    <Card className="w-100 flex-fill mb-2">
                        <CardBody className="text-center m-0 p-1">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 text-center" style={{ width: '20%' }}>
                                    <i className="text-muted ri-windy-line" style={{ fontSize: '24px' }}></i>
                                </div>
                                <div className="flex-grow-1">
                                <h3 className="fs-13 fw-bold mb-0">{data?.wind?.speed_kmh ?? '-'} km/h</h3>
                                <h3 className="fs-13 fw-bold mb-0">{data?.wind?.speed_knot ?? '-'} nudos</h3>
                                    <p className="fs-10 m-0 text-uppercase fw-medium text-muted text-truncate">
                                        Viento <i className={getWindIcon(data?.wind?.direction)}></i> {data?.wind?.direction ?? '-'}
                                    </p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className="w-100 flex-fill mb-2">
                        <CardBody className="text-center m-0 p-1">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 text-center" style={{ width: '20%' }}>
                                    <i className="text-muted ri-windy-fill" style={{ fontSize: '24px' }}></i>
                                </div>
                                <div className="flex-grow-1">
                                <h3 className="fs-13 fw-bold mb-0">{data?.wind?.speed_kmh ?? '-'} km/h</h3>
                                <h3 className="fs-13 fw-bold mb-0">{data?.wind?.gust_knot ?? '-'} nudos</h3>
                                    <p className="fs-10 m-0 text-uppercase fw-medium text-muted text-truncate">Ráfagas</p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                <div className="d-flex gap-2">
                    <Card className="w-100 flex-fill mb-2">
                        <CardBody className="text-center m-0 p-1">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 text-center" style={{ width: '20%' }}>
                                    <i className="text-muted ri-haze-line" style={{ fontSize: '24px' }}></i>
                                </div>
                                <div className="flex-grow-1">
                                    <h3 className="fs-13 fw-bold mb-0">{sunriseTime}</h3>
                                    <p className="fs-10 m-0 text-uppercase fw-medium text-muted text-truncate">Amanecer</p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className="w-100 flex-fill mb-2">
                        <CardBody className="text-center m-0 p-1">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 text-center" style={{ width: '20%' }}>
                                    <i className="text-muted ri-haze-fill" style={{ fontSize: '24px' }}></i>
                                </div>
                                <div className="flex-grow-1">
                                    <h3 className="fs-13 fw-bold mb-0">{sunsetTime}</h3>
                                    <p className="fs-10 m-0 text-uppercase fw-medium text-muted text-truncate">Atardecer</p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </section>
        </React.Fragment>

    );
};

export default WeatherForecastVariable;
